import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoMenu from "./../../services/bao-menu";
import BaseViewModel from "./../../factories/base-view-model";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import "./../../bindings/bao-number-box";
function SecurityPolicyViewModel(tabPage) {
    var self = this;
    BaseViewModel.call(this, tabPage);
    self.PasswordLength = ko.observable();
    self.CapitalCharacter = ko.observable();
    self.SpecialCharacter = ko.observable();
    self.SpecialCharactersPool = ko.observable();
    self.NumberCharacter = ko.observable();
    self.PasswordHistory = ko.observable();
    self.InvalidPassword = ko.observable();
    self.CompleteCheck = function () {
        var isComplete = true;
        var def = $.Deferred();
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        def.resolve(isComplete);
        return def.promise();
    };
    self.Refresh = function () {
        var self = this;
        if (self.TabPage.DirtyFlag() == true && (self.SaveAllowed == null || self.SaveAllowed())) {
            var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage(self.SaveCheckMessageKey), "question");
            questionDialog.DialogResult.subscribe(function (result) {
                if (result == true) {
                    self.CompleteCheck().then(function (completeCheckResult) {
                        if (completeCheckResult) {
                            self.Save();
                        }
                    });
                }
                else if (result === false) {
                    self.PerformRefresh();
                }
            });
        }
        else {
            self.PerformRefresh();
        }
    };
    self.PerformRefresh = function () {
        tabPage.IsLoading(true);
        return Bao.post("Uadm/SecurityPolicy/GetSecurityPolicy", JSON.stringify({}), function (value) {
            tabPage.DirtyFlag.pause();
            ko.map.fromJS(value, self, tabPage.DirtyFlag);
            // Set special characters to 0 if SpecialCharactersPool is set to null in the DB
            if (!self.SpecialCharactersPool()) {
                self.SpecialCharacter(0);
            }
            tabPage.IsLoading(false);
            tabPage.DirtyFlag.reset();
        });
    };
    self.Save = function () {
        tabPage.IsLoading(true);
        var model = ko.map.toJS(self, true);
        delete model.TabPage;
        return Bao.post("Uadm/SecurityPolicy/SaveSecurityPolicy", JSON.stringify({
            model: model
        })).then(function () {
            self.PerformRefresh();
        });
    };
    self.loaded = function () {
        tabPage.DirtyFlag.reset();
        tabPage.IsLoading(false);
        self.ShowStatusDialog = false;
        self.PerformRefresh();
    };
    BaoMenu.registerEvent(function (value) {
        if (tabPage.IsActiveTab() == true) {
            switch (value.ActionKey()) {
                case "SecurityPolicySave":
                    self.Save();
                    break;
                case "SecurityPolicyRefresh":
                    self.Refresh();
                    break;
            }
        }
    });
}
;
Bao.inherit(SecurityPolicyViewModel, BaseViewModel);
export default SecurityPolicyViewModel;